/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

/**
 * The role of the person performing an action or viewing data
 */
export enum ActorTypes {
  ADMIN_USER = "ADMIN_USER",
  CATERER_ACCOUNT = "CATERER_ACCOUNT",
  CUSTOMER = "CUSTOMER",
  SYSTEM = "SYSTEM",
}

/**
 * Auto bidding goal for campaign optimization
 */
export enum AutoBidGoalEnum {
  BALANCED = "BALANCED",
  EFFICIENCY = "EFFICIENCY",
  VISIBILITY = "VISIBILITY",
}

/**
 * The available comparison operators that can be used in auto-ezDispatch rule conditions.
 */
export enum AutoEzDispatchRuleComparator {
  EQUAL_TO = "EQUAL_TO",
  GREATER_THAN = "GREATER_THAN",
  LESS_THAN = "LESS_THAN",
}

/**
 * The possible rule definitions for auto-requesting ezDispatch. This determines how a rule functions.
 */
export enum AutoEzDispatchRuleKey {
  DELIVERY_DISTANCE = "DELIVERY_DISTANCE",
  EVENT_LEAD_TIME = "EVENT_LEAD_TIME",
  ORDER_SIZE = "ORDER_SIZE",
  TIME_OF_DAY = "TIME_OF_DAY",
}

/**
 * The status of potential auto intervention based on performance metrics
 */
export enum AutoInterventionStatusType {
  ACTIVE = "ACTIVE",
  PAUSED = "PAUSED",
  UNPAUSED = "UNPAUSED",
  WARNED = "WARNED",
}

/**
 * Status of a campaign
 */
export enum CampaignStatusEnum {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}

/**
 * Entities that can cancel an order
 */
export enum CancelledByEnum {
  CATERER = "CATERER",
  CUSTOMER = "CUSTOMER",
  EZCATER = "EZCATER",
  TPD_PARTNER = "TPD_PARTNER",
}

/**
 * Reasons an order was cancelled
 */
export enum CancelledByReasonEnum {
  ASSIGN_NEW_DOORDASH_DRIVER = "ASSIGN_NEW_DOORDASH_DRIVER",
  ATTENDANCE_CHANGE = "ATTENDANCE_CHANGE",
  AT_DAILY_CAPACITY = "AT_DAILY_CAPACITY",
  AT_HOURLY_CAPACITY = "AT_HOURLY_CAPACITY",
  BETTER_OPTION_FOUND = "BETTER_OPTION_FOUND",
  BUDGET_REASONS = "BUDGET_REASONS",
  CANCELLED_ACCOUNT = "CANCELLED_ACCOUNT",
  CATERER_REQUESTED_TO_CANCEL_EZDISPATCH_LESS_THAN_2_HOURS_OUT = "CATERER_REQUESTED_TO_CANCEL_EZDISPATCH_LESS_THAN_2_HOURS_OUT",
  CATERER_UNABLE_TO_APPROVE_LAST_MIN_MODIFICATION = "CATERER_UNABLE_TO_APPROVE_LAST_MIN_MODIFICATION",
  CHANGED_MIND = "CHANGED_MIND",
  CHANGE_FROM_DELIVERY_TO_TAKEOUT = "CHANGE_FROM_DELIVERY_TO_TAKEOUT",
  CHANGE_IN_EVENT_DATE = "CHANGE_IN_EVENT_DATE",
  COMMISSION_OR_FEES_TOO_HIGH = "COMMISSION_OR_FEES_TOO_HIGH",
  CUSTOMER_APPROVAL_NOT_RECEIVED = "CUSTOMER_APPROVAL_NOT_RECEIVED",
  CUSTOMER_DOES_NOT_WANT_EZ_DISPATCH = "CUSTOMER_DOES_NOT_WANT_EZ_DISPATCH",
  DATE_CHANGE_NO_DUPE_NEEDED = "DATE_CHANGE_NO_DUPE_NEEDED",
  DID_NOT_MEAN_TO_ORDER = "DID_NOT_MEAN_TO_ORDER",
  DISTANCE_TOO_FAR = "DISTANCE_TOO_FAR",
  DOES_NOT_OFFER_TAKE_OUT_OR_DELIVERY = "DOES_NOT_OFFER_TAKE_OUT_OR_DELIVERY",
  DOES_NOT_REMEMBER_SIGNING_UP_FOR_EZCATER = "DOES_NOT_REMEMBER_SIGNING_UP_FOR_EZCATER",
  DONT_REMEMBER_SIGNING_UP_FOR_EZCATER = "DONT_REMEMBER_SIGNING_UP_FOR_EZCATER",
  EMERGENCY_CLOSURE = "EMERGENCY_CLOSURE",
  EVENT_CANCELLED = "EVENT_CANCELLED",
  FOUND_DIFFERENT_CATERER = "FOUND_DIFFERENT_CATERER",
  FRAUDULENT = "FRAUDULENT",
  FRAUDULENT_CP = "FRAUDULENT_CP",
  FRAUDULENT_CUSTOMER = "FRAUDULENT_CUSTOMER",
  HOLIDAY_CLOSURE = "HOLIDAY_CLOSURE",
  LACK_OF_INVENTORY = "LACK_OF_INVENTORY",
  LEAD_TIME_TOO_SHORT_TO_DELIVER = "LEAD_TIME_TOO_SHORT_TO_DELIVER",
  LEAD_TIME_TOO_SHORT_TO_PREPARE = "LEAD_TIME_TOO_SHORT_TO_PREPARE",
  LEGACY_ORDER = "LEGACY_ORDER",
  LOCATION_CLOSED = "LOCATION_CLOSED",
  LOWER_OFFER_FROM_RESTAURANT = "LOWER_OFFER_FROM_RESTAURANT",
  MENU_CHANGE_OR_UPCHARGE = "MENU_CHANGE_OR_UPCHARGE",
  MENU_INCORRECT = "MENU_INCORRECT",
  MISSING_CUSTOMER_CONTACT_INFORMATION = "MISSING_CUSTOMER_CONTACT_INFORMATION",
  MODIFICATION_NEEDED = "MODIFICATION_NEEDED",
  NEGATIVE_EZCATER_EXPERIENCE = "NEGATIVE_EZCATER_EXPERIENCE",
  NONE_PROVIDED = "NONE_PROVIDED",
  NOT_ENOUGH_DRIVERS = "NOT_ENOUGH_DRIVERS",
  NOT_ENOUGH_NOTICE = "NOT_ENOUGH_NOTICE",
  NOT_ENOUGH_NOTICE_TO_DELIVER = "NOT_ENOUGH_NOTICE_TO_DELIVER",
  NOT_ENOUGH_NOTICE_TO_PREPARE = "NOT_ENOUGH_NOTICE_TO_PREPARE",
  NO_DRIVERS_AVAILABLE = "NO_DRIVERS_AVAILABLE",
  NO_DRIVER_AVAILABLE = "NO_DRIVER_AVAILABLE",
  NO_TIP = "NO_TIP",
  ON_VACATION = "ON_VACATION",
  OTHER = "OTHER",
  OUT_OF_BUSINESS = "OUT_OF_BUSINESS",
  OWNERSHIP_CHANGED = "OWNERSHIP_CHANGED",
  PAYMENT_ISSUES = "PAYMENT_ISSUES",
  PERMANENTLY_CLOSED = "PERMANENTLY_CLOSED",
  REASON_NOT_LISTED = "REASON_NOT_LISTED",
  REASON_NOT_PROVIDED = "REASON_NOT_PROVIDED",
  REMOVE_EZDISPATCH_FROM_THE_ORDER = "REMOVE_EZDISPATCH_FROM_THE_ORDER",
  RESTAURANT_CANNOT_ACCOMMODATE = "RESTAURANT_CANNOT_ACCOMMODATE",
  SICK_OR_ILLNESS = "SICK_OR_ILLNESS",
  STAFF_SHORTAGE = "STAFF_SHORTAGE",
  STORE_CHANGE = "STORE_CHANGE",
  TECHNICAL_ISSUE = "TECHNICAL_ISSUE",
  TEMPORARILY_CLOSED = "TEMPORARILY_CLOSED",
  TOO_BUSY = "TOO_BUSY",
  TOO_FAR = "TOO_FAR",
  UNABLE_TO_DELIVER = "UNABLE_TO_DELIVER",
  UNABLE_TO_PREPARE = "UNABLE_TO_PREPARE",
  UNFORESEEN_CIRCUMSTANCES = "UNFORESEEN_CIRCUMSTANCES",
  UNPROFESSIONAL_CATERER = "UNPROFESSIONAL_CATERER",
  UNPROFESSIONAL_DRIVER = "UNPROFESSIONAL_DRIVER",
  UNRESPONSIVE_CATERER = "UNRESPONSIVE_CATERER",
  WEATHER = "WEATHER",
  WRONG_DELIVERY_FEE = "WRONG_DELIVERY_FEE",
  WRONG_DELIVERY_TIME = "WRONG_DELIVERY_TIME",
  WRONG_HOURS = "WRONG_HOURS",
  WRONG_MENU_PRICES = "WRONG_MENU_PRICES",
  WRONG_MINIMUM = "WRONG_MINIMUM",
  WRONG_ORDER_INFO = "WRONG_ORDER_INFO",
  WRONG_STORE_HOURS = "WRONG_STORE_HOURS",
}

/**
 * Allowed values for capacity limit types
 */
export enum CapacityLimit {
  DAILY = "DAILY",
  MEAL_TIME = "MEAL_TIME",
}

/**
 * Allowed values credit card type field
 */
export enum CardType {
  AMERICAN_EXPRESS = "AMERICAN_EXPRESS",
  BLANK = "BLANK",
  DISCOVER = "DISCOVER",
  MASTER = "MASTER",
  VISA = "VISA",
}

/**
 * Allowed values for sorting a caterer account's list of stores
 */
export enum CatererAccountStoreSortField {
  ADDRESS = "ADDRESS",
  CITY = "CITY",
  NICKNAME = "NICKNAME",
  STATE = "STATE",
  STORE_NUMBER = "STORE_NUMBER",
  UPDATED_AT = "UPDATED_AT",
}

/**
 * Status of a caterer dispute
 */
export enum CatererDisputeStatus {
  APPROVED = "APPROVED",
  DENIED = "DENIED",
  PARTIAL_REFUND = "PARTIAL_REFUND",
  PENDING = "PENDING",
}

/**
 * Different types of information messages that can be displayed on an order
 */
export enum CatererOrderMessagesEnum {
  CANCELLATION_CONFIRMED_BY_CATERER = "CANCELLATION_CONFIRMED_BY_CATERER",
  NEEDS_ACCEPTANCE_AFTER_THIRD_PARTY_DELIVERY_FAILED = "NEEDS_ACCEPTANCE_AFTER_THIRD_PARTY_DELIVERY_FAILED",
  NOTE = "NOTE",
  PCP_TRIAL_EXPIRED = "PCP_TRIAL_EXPIRED",
  REJECTED = "REJECTED",
  REVISED = "REVISED",
  STANDARD_GROUP_ORDER = "STANDARD_GROUP_ORDER",
  THIRD_PARTY_DELIVERY_REQUESTED = "THIRD_PARTY_DELIVERY_REQUESTED",
  THIRD_PARTY_DELIVERY_REQUEST_ACCEPTED = "THIRD_PARTY_DELIVERY_REQUEST_ACCEPTED",
}

/**
 * Allowed values for the order sort field
 */
export enum CatererOrderSortField {
  EVENT_AT = "EVENT_AT",
}

/**
 * Allowed values for an order's status
 */
export enum CatererOrderStatusEnum {
  accepted = "accepted",
  cancelled = "cancelled",
  changes_requested = "changes_requested",
  completed = "completed",
  food_delivered = "food_delivered",
  food_prepped = "food_prepped",
  needs_acceptance = "needs_acceptance",
  needs_acknowledgement = "needs_acknowledgement",
  needs_confirm_cancellation = "needs_confirm_cancellation",
  needs_confirm_modification = "needs_confirm_modification",
  needs_driver_assignment = "needs_driver_assignment",
  needs_food_prep = "needs_food_prep",
  new = "new",
  paid = "paid",
  payment_failed = "payment_failed",
  pending_payment = "pending_payment",
  rejected = "rejected",
  third_party_delivery_requested = "third_party_delivery_requested",
}

/**
 * The reasons for pausing a caterer
 */
export enum CatererPauseReasons {
  CANCELLATIONS = "CANCELLATIONS",
  COMPLIANCE = "COMPLIANCE",
  FOOD_NOT_READY = "FOOD_NOT_READY",
  LIEN_NEGOTIATIONS = "LIEN_NEGOTIATIONS",
  METRICS_RESET = "METRICS_RESET",
  OWNERSHIP_TRANSFER = "OWNERSHIP_TRANSFER",
  PAYMENT_UPDATES = "PAYMENT_UPDATES",
  PERFORMANCE = "PERFORMANCE",
  PROLONGED_TEMP_CLOSURE = "PROLONGED_TEMP_CLOSURE",
  REJECTIONS = "REJECTIONS",
  SUSPECTED_FRAUD = "SUSPECTED_FRAUD",
  SUSPECTED_NON_COMMERCIAL_KITCHEN = "SUSPECTED_NON_COMMERCIAL_KITCHEN",
  SUSPECTED_OOB = "SUSPECTED_OOB",
  SUSPECTED_OOB_CANCEL_REJECT = "SUSPECTED_OOB_CANCEL_REJECT",
  SUSPECTED_OOB_YELP = "SUSPECTED_OOB_YELP",
  TIMELINESS = "TIMELINESS",
  VIRTUAL_BRAND = "VIRTUAL_BRAND",
}

/**
 * The current status of a caterer report
 */
export enum CatererReportStatus {
  COMPLETED = "COMPLETED",
  DOWNLOADED = "DOWNLOADED",
  PROCESSING = "PROCESSING",
}

/**
 * Allowed values for a CatererSubmittedOrderMetadatum payment method
 */
export enum CatererSubmittedOrderMetadatumPaymentMethod {
  CREDIT_CARD = "CREDIT_CARD",
  HOUSE_ACCOUNT = "HOUSE_ACCOUNT",
  INVOICE = "INVOICE",
  IN_STORE = "IN_STORE",
  LINE_OF_CREDIT = "LINE_OF_CREDIT",
}

/**
 * Allowed values for payment method type
 */
export enum CatererVendorPaymentTypeEnum {
  ACH = "ACH",
  CHECK = "CHECK",
  CREDIT_CARD = "CREDIT_CARD",
  MANUAL_CHECK = "MANUAL_CHECK",
  NO_PAYMENT = "NO_PAYMENT",
  ONE_OFF_CHECK = "ONE_OFF_CHECK",
}

/**
 * Allowed fields for sorting catering partner accounts.
 */
export enum CateringPartnerAccountSortField {
  ACCOUNT_STATUS = "ACCOUNT_STATUS",
  ACCOUNT_TYPE = "ACCOUNT_TYPE",
  EMAIL = "EMAIL",
  NAME = "NAME",
}

/**
 * Allowed fields for filtering catering partner accounts by their portal status.
 */
export enum CateringPartnerAccountStatusFilter {
  ACTIVE = "ACTIVE",
  ALL = "ALL",
  ALL_ACTIVE_AND_INVITED = "ALL_ACTIVE_AND_INVITED",
  INACTIVE = "INACTIVE",
  INVITED = "INVITED",
  NON_DEACTIVATED = "NON_DEACTIVATED",
  NO_ACCOUNT = "NO_ACCOUNT",
}

export enum ComparatorTargetEnum {
  NEARBY_RESTAURANTS = "NEARBY_RESTAURANTS",
  PRIOR_YEAR = "PRIOR_YEAR",
}

/**
 * Allowed values for a Contact's account status
 */
export enum ContactAccountStatusEnum {
  ACTIVE = "ACTIVE",
  DEACTIVATED = "DEACTIVATED",
  NEEDS_ACTIVATION = "NEEDS_ACTIVATION",
  NO_ACCOUNT = "NO_ACCOUNT",
  PASSWORD_RESET = "PASSWORD_RESET",
}

/**
 * The types of notifications we send to catering partners.
 */
export enum ContactNotificationTypes {
  BILLING_ON_EMAIL1 = "BILLING_ON_EMAIL1",
  BILLING_ON_EMAIL2 = "BILLING_ON_EMAIL2",
  BILLING_ON_EMAIL3 = "BILLING_ON_EMAIL3",
  CATERER_ACCEPT_ON_PHONE1 = "CATERER_ACCEPT_ON_PHONE1",
  CATERER_ACCEPT_ON_PHONE2 = "CATERER_ACCEPT_ON_PHONE2",
  CATERER_ACCEPT_ON_PHONE3 = "CATERER_ACCEPT_ON_PHONE3",
  DELIVERY_REMINDER_ON_EMAIL1 = "DELIVERY_REMINDER_ON_EMAIL1",
  DELIVERY_REMINDER_ON_EMAIL2 = "DELIVERY_REMINDER_ON_EMAIL2",
  DELIVERY_REMINDER_ON_EMAIL3 = "DELIVERY_REMINDER_ON_EMAIL3",
  FOOD_PREP_ON_PHONE1 = "FOOD_PREP_ON_PHONE1",
  FOOD_PREP_ON_PHONE2 = "FOOD_PREP_ON_PHONE2",
  FOOD_PREP_ON_PHONE3 = "FOOD_PREP_ON_PHONE3",
  ORDER_TRANSMISSION_ON_EMAIL1 = "ORDER_TRANSMISSION_ON_EMAIL1",
  ORDER_TRANSMISSION_ON_EMAIL2 = "ORDER_TRANSMISSION_ON_EMAIL2",
  ORDER_TRANSMISSION_ON_EMAIL3 = "ORDER_TRANSMISSION_ON_EMAIL3",
  ORDER_TRANSMISSION_ON_FAX = "ORDER_TRANSMISSION_ON_FAX",
  ORDER_TRANSMISSION_ON_PHONE1 = "ORDER_TRANSMISSION_ON_PHONE1",
  ORDER_TRANSMISSION_ON_PHONE2 = "ORDER_TRANSMISSION_ON_PHONE2",
  ORDER_TRANSMISSION_ON_PHONE3 = "ORDER_TRANSMISSION_ON_PHONE3",
}

/**
 * The types of transmission methods that can be used to reach out to a caterer contact.
 */
export enum ContactOrderNotificationMethodEnum {
  EMAIL = "EMAIL",
  FAX = "FAX",
  PHONE = "PHONE",
  TEXT = "TEXT",
}

/**
 * Descriptive labels for how a particular contact phone number is used.
 */
export enum ContactPhoneNumberTypesEnum {
  CATERING = "CATERING",
  DIRECTENTRY = "DIRECTENTRY",
  HOME = "HOME",
  KITCHEN = "KITCHEN",
  MOBILE = "MOBILE",
  NONE = "NONE",
  OFFICE = "OFFICE",
  PHONE = "PHONE",
  STORE = "STORE",
  WORK = "WORK",
}

/**
 * Types of content filters that may have triggered for a given message
 */
export enum ContentFilterTypes {
  BUSINESS_CONCERNS = "BUSINESS_CONCERNS",
  INAPPROPRIATENESS = "INAPPROPRIATENESS",
  MISDIRECTION = "MISDIRECTION",
  TONE = "TONE",
}

/**
 * Allowed currency values for money
 */
export enum Currency {
  USD = "USD",
}

/**
 * Allowed values for days of the week
 */
export enum DaysOfWeek {
  FRIDAY = "FRIDAY",
  MONDAY = "MONDAY",
  SATURDAY = "SATURDAY",
  SUNDAY = "SUNDAY",
  THURSDAY = "THURSDAY",
  TUESDAY = "TUESDAY",
  WEDNESDAY = "WEDNESDAY",
}

/**
 * Types of Direct Connect events present in a history
 */
export enum DcEventTypes {
  CANCELLATION = "CANCELLATION",
  DECISION = "DECISION",
  MESSAGE = "MESSAGE",
  REQUEST = "REQUEST",
}

export enum DeliveryFeeFeeTypeEnum {
  CUSTOM = "CUSTOM",
  FIXED = "FIXED",
  PERCENT_OF_FOOD = "PERCENT_OF_FOOD",
  PER_MILE = "PER_MILE",
}

/**
 * Allowed values for the review delivery professional feedback field
 */
export enum DeliveryProfessionalismFeedback {
  HIGHLY_PROFESSIONAL = "HIGHLY_PROFESSIONAL",
  HIGHLY_UNPROFESSIONAL = "HIGHLY_UNPROFESSIONAL",
  NEUTRAL = "NEUTRAL",
  PROFESSIONAL = "PROFESSIONAL",
  UNPROFESSIONAL = "UNPROFESSIONAL",
}

/**
 * Allowed values for delivery setup
 */
export enum DeliverySetup {
  NONE = "NONE",
  NO_RESPONSE = "NO_RESPONSE",
  REQUIRED = "REQUIRED",
}

/**
 * Allowed values for sorting a list of delivery objects
 */
export enum DeliverySortFields {
  DRIVER_NAME = "DRIVER_NAME",
  EVENT_AT = "EVENT_AT",
}

/**
 * Allowed values for the review delivery time feedback field
 */
export enum DeliveryTimeFeedback {
  EARLY = "EARLY",
  LATE = "LATE",
  ON_TIME = "ON_TIME",
}

export enum DeliveryZoneZoneTypeEnum {
  CIRCLE = "CIRCLE",
  CITY = "CITY",
  DISTANCE = "DISTANCE",
  POLYGON = "POLYGON",
  RECTANGLE = "RECTANGLE",
  ZIP_CODE = "ZIP_CODE",
}

/**
 * Allowed values for discount types
 */
export enum DiscountTypeEnum {
  dollar_off = "dollar_off",
  percent_off = "percent_off",
}

/**
 * The event type for any given event
 */
export enum DmDeliveryEventTypes {
  accepted = "accepted",
  assignment_cancelled = "assignment_cancelled",
  assignment_created = "assignment_created",
  cancelled = "cancelled",
  created = "created",
  driver_arrived_at_dropoff = "driver_arrived_at_dropoff",
  driver_arrived_at_pickup = "driver_arrived_at_pickup",
  driver_assigned = "driver_assigned",
  driver_dropped_off = "driver_dropped_off",
  driver_en_route_to_dropoff = "driver_en_route_to_dropoff",
  driver_en_route_to_pickup = "driver_en_route_to_pickup",
  driver_picked_up = "driver_picked_up",
  driver_provided_feedback = "driver_provided_feedback",
  driver_reported_lateness = "driver_reported_lateness",
  driver_reported_location = "driver_reported_location",
  driver_unassigned = "driver_unassigned",
  expired = "expired",
  issue = "issue",
  modified = "modified",
  rejected = "rejected",
  request_deleted_by_caterer = "request_deleted_by_caterer",
  request_deleted_by_customer = "request_deleted_by_customer",
  request_deleted_by_delivery_partner = "request_deleted_by_delivery_partner",
}

/**
 * Current state - unassigned, assigned, in_progress, completed or expired - based on associated delivery events
 */
export enum DmDeliveryStatus {
  assigned = "assigned",
  completed = "completed",
  expired = "expired",
  in_progress = "in_progress",
  unassigned = "unassigned",
}

/**
 * The vendor hosting the image.
 */
export enum DmDriverImageVendor {
  FILESTACK = "FILESTACK",
}

/**
 * Driver current SMS opt in status - no opt in decision, opted in, opted out
 */
export enum DmDriverOptInStatus {
  NO_OPT_IN_DECISION = "NO_OPT_IN_DECISION",
  OPTED_IN = "OPTED_IN",
  OPTED_OUT = "OPTED_OUT",
}

export enum EntityTypeEnum {
  brand = "brand",
  caterer = "caterer",
}

/**
 * The ezDispatch delivery lifecycle status.
 */
export enum EzDispatchDeliveryStatus {
  ACCEPTED = "ACCEPTED",
  CANCELLED = "CANCELLED",
  DELETED = "DELETED",
  PENDING = "PENDING",
  REJECTED = "REJECTED",
}

/**
 * Values corresponding to ezManage permissions types for a catering partner account.
 */
export enum EzManagePermissionTypes {
  BRAND_ADMIN = "BRAND_ADMIN",
  CAN_ACCEPT_REJECT_ORDERS = "CAN_ACCEPT_REJECT_ORDERS",
  CAN_CREATE_MENUS_VIA_API = "CAN_CREATE_MENUS_VIA_API",
  CAN_CREATE_PUBLIC_API_CREDENTIALS = "CAN_CREATE_PUBLIC_API_CREDENTIALS",
  CAN_CREATE_STORE_HOURS_VIA_API = "CAN_CREATE_STORE_HOURS_VIA_API",
  CAN_EDIT_DIRECT_ENTRY_CUSTOM_MENU_ITEMS = "CAN_EDIT_DIRECT_ENTRY_CUSTOM_MENU_ITEMS",
  CAN_EDIT_DIRECT_ENTRY_DISCOUNTS_FEES = "CAN_EDIT_DIRECT_ENTRY_DISCOUNTS_FEES",
  CAN_EDIT_LEAD_TIMES = "CAN_EDIT_LEAD_TIMES",
  CAN_EDIT_OPERATING_HOURS = "CAN_EDIT_OPERATING_HOURS",
  CAN_EDIT_RANKINGS = "CAN_EDIT_RANKINGS",
  CAN_EDIT_STORE_DETAILS = "CAN_EDIT_STORE_DETAILS",
  CAN_EDIT_TEMPORARY_CLOSURES = "CAN_EDIT_TEMPORARY_CLOSURES",
  CAN_EDIT_USER_SETTINGS = "CAN_EDIT_USER_SETTINGS",
  CAN_MANAGE_DEMOGRAPHIC_DATA = "CAN_MANAGE_DEMOGRAPHIC_DATA",
  CAN_MANAGE_PROMOS = "CAN_MANAGE_PROMOS",
  CAN_REQUEST_SETTINGS_UPDATE = "CAN_REQUEST_SETTINGS_UPDATE",
  CAN_VIEW_DELIVERY_MANAGEMENT = "CAN_VIEW_DELIVERY_MANAGEMENT",
  CAN_VIEW_DIRECT_CONNECT_MESSAGES = "CAN_VIEW_DIRECT_CONNECT_MESSAGES",
  CAN_VIEW_DIRECT_ENTRY = "CAN_VIEW_DIRECT_ENTRY",
  CAN_VIEW_ORDERS = "CAN_VIEW_ORDERS",
  CAN_VIEW_ORDER_PRICES = "CAN_VIEW_ORDER_PRICES",
  CAN_VIEW_PAYMENTS = "CAN_VIEW_PAYMENTS",
  CAN_VIEW_PERFORMANCE = "CAN_VIEW_PERFORMANCE",
  CAN_VIEW_RANKINGS = "CAN_VIEW_RANKINGS",
  CAN_VIEW_REPORTS = "CAN_VIEW_REPORTS",
  CAN_VIEW_REVIEWS = "CAN_VIEW_REVIEWS",
  CAN_VIEW_SETTINGS = "CAN_VIEW_SETTINGS",
  CAN_WRITE_DIRECT_CONNECT_MESSAGES = "CAN_WRITE_DIRECT_CONNECT_MESSAGES",
}

/**
 * Allowed values for EzManageScopedActivationPermission error field
 */
export enum EzManageScopedActivationPermissionError {
  BRAND_ADMIN = "BRAND_ADMIN",
  MISSING_STORES = "MISSING_STORES",
  NOT_AUTHORIZED = "NOT_AUTHORIZED",
}

/**
 * Categories of fulfillment issues
 */
export enum FulfillmentIssueCategory {
  DELIVERY_ISSUE = "DELIVERY_ISSUE",
  FOOD_WAS_NOT_READY_FOR_DELIVERY = "FOOD_WAS_NOT_READY_FOR_DELIVERY",
  MISSING_FOOD = "MISSING_FOOD",
  OTHER = "OTHER",
  UNCATEGORIZED = "UNCATEGORIZED",
}

/**
 * The codes associated with fulfillment issues
 */
export enum FulfillmentIssueCode {
  ACT_OF_GOD = "ACT_OF_GOD",
  CATERER_MISCOMMUNICATION = "CATERER_MISCOMMUNICATION",
  CUSTOMER_MISCOMMUNICATION = "CUSTOMER_MISCOMMUNICATION",
  CUSTOMER_UNPROFESSIONAL = "CUSTOMER_UNPROFESSIONAL",
  DELIVERY_INSTRUCTIONS_NOT_FOLLOWED = "DELIVERY_INSTRUCTIONS_NOT_FOLLOWED",
  DELIVERY_OUTSOURCED = "DELIVERY_OUTSOURCED",
  DELIVERY_PARTIALLY_TRACKED = "DELIVERY_PARTIALLY_TRACKED",
  DELIVERY_UNTRACKED = "DELIVERY_UNTRACKED",
  DIETARY_REQUESTS_NOT_ACCOMMODATED = "DIETARY_REQUESTS_NOT_ACCOMMODATED",
  DRIVER_DID_NOT_ADHERE_FOOD_SAFETY_REGULATIONS = "DRIVER_DID_NOT_ADHERE_FOOD_SAFETY_REGULATIONS",
  DRIVER_MISSING_DELIVERY_EQUIPMENT = "DRIVER_MISSING_DELIVERY_EQUIPMENT",
  DROPPED_OFF_TO_WRONG_LOCATION = "DROPPED_OFF_TO_WRONG_LOCATION",
  EARLY = "EARLY",
  EZCATER_MISCOMMUNICATION = "EZCATER_MISCOMMUNICATION",
  EZCATER_TECHNOLOGY_ISSUE = "EZCATER_TECHNOLOGY_ISSUE",
  EZD_CATERER_FULFILLED_ORDER = "EZD_CATERER_FULFILLED_ORDER",
  EZD_DRIVER_LATE_TO_PICKUP = "EZD_DRIVER_LATE_TO_PICKUP",
  EZD_DRIVER_LATE_TO_PICKUP_FIFTEEN_TO_THIRTY_MINUTES_LATE = "EZD_DRIVER_LATE_TO_PICKUP_FIFTEEN_TO_THIRTY_MINUTES_LATE",
  EZD_DRIVER_LATE_TO_PICKUP_FORTY_FIVE_TO_SIXTY_MINUTES_LATE = "EZD_DRIVER_LATE_TO_PICKUP_FORTY_FIVE_TO_SIXTY_MINUTES_LATE",
  EZD_DRIVER_LATE_TO_PICKUP_SIXTY_PLUS_MINUTES_LATE = "EZD_DRIVER_LATE_TO_PICKUP_SIXTY_PLUS_MINUTES_LATE",
  EZD_DRIVER_LATE_TO_PICKUP_THIRTY_TO_FORTY_FIVE_MINUTES_LATE = "EZD_DRIVER_LATE_TO_PICKUP_THIRTY_TO_FORTY_FIVE_MINUTES_LATE",
  EZD_DRIVER_LATE_TO_PICKUP_ZERO_TO_FIFTEEN_MINUTES_LATE = "EZD_DRIVER_LATE_TO_PICKUP_ZERO_TO_FIFTEEN_MINUTES_LATE",
  EZD_DRIVER_NO_SHOW_FOR_PICKUP = "EZD_DRIVER_NO_SHOW_FOR_PICKUP",
  EZD_FOOD_NOT_READY_FOR_PICKUP = "EZD_FOOD_NOT_READY_FOR_PICKUP",
  EZD_FOOD_NOT_READY_FOR_PICKUP_FIFTEEN_TO_THIRTY_MINUTES_LATE = "EZD_FOOD_NOT_READY_FOR_PICKUP_FIFTEEN_TO_THIRTY_MINUTES_LATE",
  EZD_FOOD_NOT_READY_FOR_PICKUP_FORTY_FIVE_TO_SIXTY_MINUTES_LATE = "EZD_FOOD_NOT_READY_FOR_PICKUP_FORTY_FIVE_TO_SIXTY_MINUTES_LATE",
  EZD_FOOD_NOT_READY_FOR_PICKUP_SIXTY_PLUS_MINUTES_LATE = "EZD_FOOD_NOT_READY_FOR_PICKUP_SIXTY_PLUS_MINUTES_LATE",
  EZD_FOOD_NOT_READY_FOR_PICKUP_THIRTY_TO_FORTY_FIVE_MINUTES_LATE = "EZD_FOOD_NOT_READY_FOR_PICKUP_THIRTY_TO_FORTY_FIVE_MINUTES_LATE",
  EZD_FOOD_NOT_READY_FOR_PICKUP_ZERO_TO_FIFTEEN_MINUTES_LATE = "EZD_FOOD_NOT_READY_FOR_PICKUP_ZERO_TO_FIFTEEN_MINUTES_LATE",
  FIFTEEN_TO_THIRTY_MIN_LATE = "FIFTEEN_TO_THIRTY_MIN_LATE",
  FOOD_BAD_OR_INEDIBLE = "FOOD_BAD_OR_INEDIBLE",
  FOOD_NOT_INDIVIDUALLY_PACKAGED = "FOOD_NOT_INDIVIDUALLY_PACKAGED",
  INCORRECT_PREPARATION = "INCORRECT_PREPARATION",
  LAST_MINUTE_MODIFICATION = "LAST_MINUTE_MODIFICATION",
  LATE = "LATE",
  LATE_DELIVERY = "LATE_DELIVERY",
  LOST_DRIVER = "LOST_DRIVER",
  MISSING_FOOD = "MISSING_FOOD",
  MISSING_ORDER_ITEMS = "MISSING_ORDER_ITEMS",
  MISSING_UTENSILS_OR_OTHER_EQUIPMENT = "MISSING_UTENSILS_OR_OTHER_EQUIPMENT",
  MORE_THAN_FIFTEEN_MIN_EARLY = "MORE_THAN_FIFTEEN_MIN_EARLY",
  MORE_THAN_SIXTY_MIN_LATE = "MORE_THAN_SIXTY_MIN_LATE",
  NEVER_FULFILLED = "NEVER_FULFILLED",
  NOT_LABELED_AS_REQUESTED = "NOT_LABELED_AS_REQUESTED",
  NOT_PACKAGED_AS_REQUESTED = "NOT_PACKAGED_AS_REQUESTED",
  ORDER_DID_NOT_ARRIVE = "ORDER_DID_NOT_ARRIVE",
  ORDER_NOT_SETUP = "ORDER_NOT_SETUP",
  PACKAGING_BAD_OR_DAMAGED = "PACKAGING_BAD_OR_DAMAGED",
  THIRTY_TO_SIXTY_MIN_LATE = "THIRTY_TO_SIXTY_MIN_LATE",
  TOO_EARLY = "TOO_EARLY",
  TOO_LATE = "TOO_LATE",
  TPD_ISSUE = "TPD_ISSUE",
  UNPROFESSIONAL_DRIVER = "UNPROFESSIONAL_DRIVER",
  UNRESPONSIVE_CATERER = "UNRESPONSIVE_CATERER",
  WRONG_ORDER_DELIVERED = "WRONG_ORDER_DELIVERED",
  ZERO_TO_FIFTEEN_MIN_LATE = "ZERO_TO_FIFTEEN_MIN_LATE",
}

/**
 * The gender options for a demographic profile
 */
export enum GenderDemographic {
  DECLINE_ANSWER = "DECLINE_ANSWER",
  DIFFERENT_DESCRIPTION = "DIFFERENT_DESCRIPTION",
  MAN = "MAN",
  NON_BINARY = "NON_BINARY",
  WOMAN = "WOMAN",
}

export enum GranularityEnum {
  day = "day",
  month = "month",
  week = "week",
  year = "year",
}

/**
 * Type of campaign group distribution strategy
 */
export enum GroupTypeEnum {
  DISTRIBUTE_BY_DEMAND = "DISTRIBUTE_BY_DEMAND",
  DISTRIBUTE_EVENLY = "DISTRIBUTE_EVENLY",
}

/**
 * Allowed statuses on how menu items can be packaged
 */
export enum IndividualWrapStatus {
  CANNOT_BE_INDIVIDUALLY_WRAPPED = "CANNOT_BE_INDIVIDUALLY_WRAPPED",
  CAN_BE_INDIVIDUALLY_WRAPPED = "CAN_BE_INDIVIDUALLY_WRAPPED",
  WILL_BE_INDIVIDUALLY_WRAPPED = "WILL_BE_INDIVIDUALLY_WRAPPED",
}

/**
 * The various statuses an invoice can have
 */
export enum InvoiceStatusType {
  OVERDUE = "OVERDUE",
  PAID = "PAID",
  SENT = "SENT",
}

/**
 * Allowed values for a line item's percent type
 */
export enum LineItemPercentTypeEnum {
  FOOD = "FOOD",
}

/**
 * Allowed values for line item type
 */
export enum LineItemTypeEnum {
  ADJUSTMENT = "ADJUSTMENT",
  CATERER_FUNDED_PROMO = "CATERER_FUNDED_PROMO",
  COMMISSION = "COMMISSION",
  CREDIT_CARD_FEE = "CREDIT_CARD_FEE",
  CUSTOMER_PRICING_FEE = "CUSTOMER_PRICING_FEE",
  DELIVERY_FEE = "DELIVERY_FEE",
  DISCOUNT = "DISCOUNT",
  EXTERNAL_INTEGRATION_FEE = "EXTERNAL_INTEGRATION_FEE",
  EZ_REWARDS_CREDIT = "EZ_REWARDS_CREDIT",
  MARKETPLACE_FEES_TAX = "MARKETPLACE_FEES_TAX",
  MISC_FEE = "MISC_FEE",
  POINT_OF_SALE_INTEGRATION_FEE = "POINT_OF_SALE_INTEGRATION_FEE",
  PROMO = "PROMO",
  RETAIL_DELIVERY_FEE = "RETAIL_DELIVERY_FEE",
  RETAIL_DELIVERY_FEE_REMITTANCE = "RETAIL_DELIVERY_FEE_REMITTANCE",
  SALES_TAX = "SALES_TAX",
  SALES_TAX_ADJUSTMENT = "SALES_TAX_ADJUSTMENT",
  SALES_TAX_REMITTANCE = "SALES_TAX_REMITTANCE",
}

/**
 * Transaction type of a marketing activity
 */
export enum MarketingActivityTransactionTypeEnum {
  CHARGE = "CHARGE",
  PAYMENT = "PAYMENT",
}

/**
 * Allowed values for the review delivery professional feedback field
 */
export enum MealTime {
  BREAKFAST = "BREAKFAST",
  DAY = "DAY",
  DINNER = "DINNER",
  LUNCH = "LUNCH",
}

/**
 * Allowed values for reporting period for a caterer account's menu item sales analysis.
 */
export enum MenuItemSalesAnalysisReportingPeriod {
  NINETY_DAYS = "NINETY_DAYS",
  SEVEN_DAYS = "SEVEN_DAYS",
  THIRTY_DAYS = "THIRTY_DAYS",
}

/**
 * Allowed values for sorting a caterer account's list of menu item sales analyses.
 */
export enum MenuItemSalesAnalysisSort {
  ITEMS_PRICE = "ITEMS_PRICE",
  ITEMS_SOLD = "ITEMS_SOLD",
  ITEMS_SOLD_PCT_CHG = "ITEMS_SOLD_PCT_CHG",
  ITEM_REVENUE = "ITEM_REVENUE",
  ITEM_REVENUE_PCT_CHG = "ITEM_REVENUE_PCT_CHG",
  MENU_ITEM_NAME = "MENU_ITEM_NAME",
  ORDERS_WITH_ITEM = "ORDERS_WITH_ITEM",
  ORDERS_WITH_ITEM_PCT_CHG = "ORDERS_WITH_ITEM_PCT_CHG",
}

/**
 * Destination for menu update
 */
export enum MenuUpdateDestination {
  BOTH = "BOTH",
  EZCATER = "EZCATER",
  RELISH = "RELISH",
}

/**
 * States that a message may be in
 */
export enum MessageStatus {
  APPROVED = "APPROVED",
  BLOCKED = "BLOCKED",
  FLAGGED = "FLAGGED",
  PENDING = "PENDING",
}

/**
 * Allowed values for an order support reason
 */
export enum ModificationReasonEnum {
  ADD_ITEM = "ADD_ITEM",
  CHANGE_STORE = "CHANGE_STORE",
  DELIVERY_TIME = "DELIVERY_TIME",
  ITEM_UNAVAILABLE = "ITEM_UNAVAILABLE",
  MODIFY_ITEM = "MODIFY_ITEM",
  OTHER = "OTHER",
  PRICE_ADJUSTMENT = "PRICE_ADJUSTMENT",
  REQUEST_CLARIFICATION = "REQUEST_CLARIFICATION",
  REQUEST_EZDISPATCH = "REQUEST_EZDISPATCH",
  REQUEST_EZDISPATCH_WHENEVER = "REQUEST_EZDISPATCH_WHENEVER",
}

/**
 * Available onboarding form pages with UI page header titles
 */
export enum OnboardingFormPageEnum {
  HOURS_AND_DELIVERY_1 = "HOURS_AND_DELIVERY_1",
  HOURS_AND_DELIVERY_2 = "HOURS_AND_DELIVERY_2",
  MENU = "MENU",
  PAYMENT_INFO_1 = "PAYMENT_INFO_1",
  PAYMENT_INFO_2 = "PAYMENT_INFO_2",
  STORE_AND_CONTACT_INFO_1 = "STORE_AND_CONTACT_INFO_1",
  STORE_AND_CONTACT_INFO_2 = "STORE_AND_CONTACT_INFO_2",
}

/**
 * Allowed values for source of operating hours
 */
export enum OperatingHoursSource {
  API = "API",
  HUMAN = "HUMAN",
}

/**
 * Allowed values for sorting a caterer account's list of stores
 */
export enum OperationalMetricsStoreSortField {
  ADJUSTED_AVG_STAR_RATING = "ADJUSTED_AVG_STAR_RATING",
  AUTO_INTERVENTION_STATUS = "AUTO_INTERVENTION_STATUS",
  CANCEL_PERCENT_ROLLING_90_DAYS = "CANCEL_PERCENT_ROLLING_90_DAYS",
  FOOD_READY_PERCENT_ROLLING_90_DAYS = "FOOD_READY_PERCENT_ROLLING_90_DAYS",
  IS_RELIABILITY_ROCKSTAR = "IS_RELIABILITY_ROCKSTAR",
  ONTIME_PERCENT_ROLLING_90_DAYS = "ONTIME_PERCENT_ROLLING_90_DAYS",
  ORDER_ACCURATE_PERCENT_ROLLING_90_DAYS = "ORDER_ACCURATE_PERCENT_ROLLING_90_DAYS",
  REJECT_PERCENT_ROLLING_90_DAYS = "REJECT_PERCENT_ROLLING_90_DAYS",
  RESPONSIVENESS_PERCENT_ROLLING_90_DAYS = "RESPONSIVENESS_PERCENT_ROLLING_90_DAYS",
  TRACKED_DELIVERY_PERCENT_ROLLING_90_DAYS = "TRACKED_DELIVERY_PERCENT_ROLLING_90_DAYS",
}

/**
 * Allowed values for the metric name field in an Operational Performance Metric
 */
export enum OperationalPerformanceMetricName {
  ADJUSTED_AVG_STAR_RATING = "ADJUSTED_AVG_STAR_RATING",
  CANCEL_PERCENT_ROLLING_90_DAYS = "CANCEL_PERCENT_ROLLING_90_DAYS",
  FOOD_READY_PERCENT_ROLLING_90_DAYS = "FOOD_READY_PERCENT_ROLLING_90_DAYS",
  ONTIME_PERCENT_ROLLING_90_DAYS = "ONTIME_PERCENT_ROLLING_90_DAYS",
  ORDER_ACCURATE_PERCENT_ROLLING_90_DAYS = "ORDER_ACCURATE_PERCENT_ROLLING_90_DAYS",
  REJECT_PERCENT_ROLLING_90_DAYS = "REJECT_PERCENT_ROLLING_90_DAYS",
  RESPONSIVENESS_PERCENT_ROLLING_90_DAYS = "RESPONSIVENESS_PERCENT_ROLLING_90_DAYS",
  TRACKED_DELIVERY_PERCENT_ROLLING_90_DAYS = "TRACKED_DELIVERY_PERCENT_ROLLING_90_DAYS",
}

/**
 * Allowed order action values
 */
export enum OrderActionsEnum {
  accept_action = "accept_action",
  acknowledge_action = "acknowledge_action",
  cancel_action = "cancel_action",
  caterer_submitted_refund_action = "caterer_submitted_refund_action",
  change_reject_action = "change_reject_action",
  complete_external_payment_action = "complete_external_payment_action",
  confirm_cancellation_action = "confirm_cancellation_action",
  confirm_modification_action = "confirm_modification_action",
  driver_assign_action = "driver_assign_action",
  edit_action = "edit_action",
  food_prep_action = "food_prep_action",
  reject_action = "reject_action",
  request_ezdispatch_action = "request_ezdispatch_action",
  request_modification_action = "request_modification_action",
  undo_complete_external_payment_action = "undo_complete_external_payment_action",
}

/**
 * Ways in which an order item may be changed
 */
export enum OrderItemChangeTypes {
  ADDITION = "ADDITION",
  DELETION = "DELETION",
  MODIFICATION = "MODIFICATION",
  SUBSTITUTION = "SUBSTITUTION",
}

/**
 * Allowed values for order sources. An order source represents what user flow the order originated from
 */
export enum OrderSource {
  CLUB_SODA = "CLUB_SODA",
  DIRECT_ENTRY = "DIRECT_ENTRY",
  EZ_ORDERING = "EZ_ORDERING",
  MARKETPLACE = "MARKETPLACE",
}

/**
 * Allowed values for order state filtering
 */
export enum OrderStateFilterEnum {
  ALL = "ALL",
  CANCELLED = "CANCELLED",
  CANCELLED_NOT_REJECTED = "CANCELLED_NOT_REJECTED",
  DRAFT = "DRAFT",
  FULFILLED_AND_UNPAID = "FULFILLED_AND_UNPAID",
  PAST = "PAST",
  PENDING_APPROVAL = "PENDING_APPROVAL",
  PENDING_REVIEW = "PENDING_REVIEW",
  RECEIPT = "RECEIPT",
  REJECTED = "REJECTED",
  REVIEWABLE = "REVIEWABLE",
  SUBMITTED = "SUBMITTED",
  SUBMITTED_NOT_CANCELLED = "SUBMITTED_NOT_CANCELLED",
  UNPAID = "UNPAID",
  UPCOMING = "UPCOMING",
  UPCOMING_AND_DRAFTS = "UPCOMING_AND_DRAFTS",
  UPCOMING_NOT_PENDING_APPROVAL = "UPCOMING_NOT_PENDING_APPROVAL",
}

/**
 * Allowed values for order type
 */
export enum OrderTypeEnum {
  DELIVERY = "DELIVERY",
  TAKEOUT = "TAKEOUT",
  THIRD_PARTY_DELIVERY = "THIRD_PARTY_DELIVERY",
}

/**
 * The ownership category options for a demographic profile
 */
export enum OwnershipCategoryDemographic {
  CORPORATE_OFFICE = "CORPORATE_OFFICE",
  FRANCHISE_GROUP = "FRANCHISE_GROUP",
  INDEPENDENT_ENTITY = "INDEPENDENT_ENTITY",
  INDEPENDENT_FRANCHISEE = "INDEPENDENT_FRANCHISEE",
}

/**
 * The ownership percentage options for a demographic profile
 */
export enum OwnershipPercentageDemographic {
  BUISNESS_OWNER_UNKNOWN = "BUISNESS_OWNER_UNKNOWN",
  NO_MAJORITY_OWNER = "NO_MAJORITY_OWNER",
  ONE_PERSON_OWNS_AT_LEAST_50_PERCENT = "ONE_PERSON_OWNS_AT_LEAST_50_PERCENT",
  TWO_PEOPLE_OWN_50_PERCENT = "TWO_PEOPLE_OWN_50_PERCENT",
}

/**
 * Representation of the type of status in terms of how it should be displayed
 */
export enum PaymentStatusDisplay {
  ERROR = "ERROR",
  WARNING = "WARNING",
}

export enum PayoneerStatus {
  approved = "approved",
  declined = "declined",
  in_progress = "in_progress",
  not_registered = "not_registered",
}

/**
 * Allowed values for the performance status field
 */
export enum PerformanceStatus {
  GREEN = "GREEN",
  RED = "RED",
  YELLOW = "YELLOW",
}

/**
 * ezCater defined holidays for caterers to opt into being closed every year
 */
export enum PredefinedHolidayType {
  CHRISTMAS_DAY = "CHRISTMAS_DAY",
  CHRISTMAS_EVE = "CHRISTMAS_EVE",
  CINCO_DE_MAYO = "CINCO_DE_MAYO",
  EARTH_DAY = "EARTH_DAY",
  EASTER_SUNDAY = "EASTER_SUNDAY",
  FATHER_S_DAY = "FATHER_S_DAY",
  HALLOWEEN = "HALLOWEEN",
  INDEPENDENCE_DAY = "INDEPENDENCE_DAY",
  INDIGENOUS_PEOPLE_S_DAY = "INDIGENOUS_PEOPLE_S_DAY",
  JUNETEENTH = "JUNETEENTH",
  LABOR_DAY = "LABOR_DAY",
  MARDI_GRAS = "MARDI_GRAS",
  MARTIN_LUTHER_KING_JR_DAY = "MARTIN_LUTHER_KING_JR_DAY",
  MEMORIAL_DAY = "MEMORIAL_DAY",
  MOTHER_S_DAY = "MOTHER_S_DAY",
  NEW_YEAR_S_DAY = "NEW_YEAR_S_DAY",
  NEW_YEAR_S_EVE = "NEW_YEAR_S_EVE",
  ST_PATRICK_S_DAY = "ST_PATRICK_S_DAY",
  THANKSGIVING = "THANKSGIVING",
  VETERANS_DAY = "VETERANS_DAY",
}

/**
 * The available funding sources for promos
 */
export enum PromoFundingTypeEnum {
  caterer_funded = "caterer_funded",
  ezcater_funded = "ezcater_funded",
}

/**
 * Allowed values for the order sort field
 */
export enum PromoOrderSortField {
  SUBMITTED_AT = "SUBMITTED_AT",
}

/**
 * The status of a promotion
 */
export enum PromoStatusEnum {
  ACTIVE = "ACTIVE",
  EXPIRED = "EXPIRED",
}

/**
 * The channels that this promo is applicable to.
 */
export enum PromoTargetChannelEnum {
  ALL = "ALL",
  MARKETPLACE = "MARKETPLACE",
  PRIVATE_STORE = "PRIVATE_STORE",
}

/**
 * The race options for a demographic profile
 */
export enum RaceDemographic {
  ASIAN_NATIVE_HAWAIIAN_PACIFIC_ISLANDER = "ASIAN_NATIVE_HAWAIIAN_PACIFIC_ISLANDER",
  BLACK_OR_AFRICAN_DESCENT = "BLACK_OR_AFRICAN_DESCENT",
  DECLINE_ANSWER = "DECLINE_ANSWER",
  DIFFERENT_DESCRIPTION = "DIFFERENT_DESCRIPTION",
  HISPANIC_LATINX_SPANISH = "HISPANIC_LATINX_SPANISH",
  INDIGENOUS_AMERICAN_INDIAN_ALASKAN_NATIVE = "INDIGENOUS_AMERICAN_INDIAN_ALASKAN_NATIVE",
  MIDDLE_EASTERN_NORTH_AFRICAN = "MIDDLE_EASTERN_NORTH_AFRICAN",
  WHITE_OR_EUROPEAN = "WHITE_OR_EUROPEAN",
}

/**
 * Allowed values for an order rejection reason
 */
export enum RejectionReasonEnum {
  AT_DAILY_CAPACITY = "AT_DAILY_CAPACITY",
  AT_HOURLY_CAPACITY = "AT_HOURLY_CAPACITY",
  COMMISSION_OR_FEES_TOO_HIGH = "COMMISSION_OR_FEES_TOO_HIGH",
  DISTANCE_TOO_FAR = "DISTANCE_TOO_FAR",
  DOES_NOT_OFFER_TAKE_OUT_OR_DELIVERY = "DOES_NOT_OFFER_TAKE_OUT_OR_DELIVERY",
  DOES_NOT_REMEMBER_SIGNING_UP_FOR_EZCATER = "DOES_NOT_REMEMBER_SIGNING_UP_FOR_EZCATER",
  EMERGENCY_CLOSURE = "EMERGENCY_CLOSURE",
  HOLIDAY_CLOSURE = "HOLIDAY_CLOSURE",
  LACK_OF_INVENTORY = "LACK_OF_INVENTORY",
  LEAD_TIME_TOO_SHORT_TO_DELIVER = "LEAD_TIME_TOO_SHORT_TO_DELIVER",
  LEAD_TIME_TOO_SHORT_TO_PREPARE = "LEAD_TIME_TOO_SHORT_TO_PREPARE",
  MENU_INCORRECT = "MENU_INCORRECT",
  MISSING_CUSTOMER_CONTACT_INFORMATION = "MISSING_CUSTOMER_CONTACT_INFORMATION",
  NO_DRIVERS_AVAILABLE = "NO_DRIVERS_AVAILABLE",
  NO_TIP = "NO_TIP",
  OUT_OF_BUSINESS = "OUT_OF_BUSINESS",
  OWNERSHIP_CHANGED = "OWNERSHIP_CHANGED",
  PERMANENTLY_CLOSED = "PERMANENTLY_CLOSED",
  REASON_NOT_LISTED = "REASON_NOT_LISTED",
  STAFF_SHORTAGE = "STAFF_SHORTAGE",
  TEMPORARILY_CLOSED = "TEMPORARILY_CLOSED",
  WEATHER = "WEATHER",
  WRONG_HOURS = "WRONG_HOURS",
}

/**
 * The statusses in which a report can be
 */
export enum ReportStatusEnum {
  COMPLETE = "COMPLETE",
  PROCESSING = "PROCESSING",
}

/**
 * States that a change request may be in
 */
export enum RequestStatus {
  ACCEPTED = "ACCEPTED",
  CANCELLED = "CANCELLED",
  COMPLETED = "COMPLETED",
  IN_PROGRESS = "IN_PROGRESS",
  PENDING = "PENDING",
  REJECTED = "REJECTED",
}

/**
 * Error messages for why a search rank address ranking cannot be calculated
 */
export enum SearchRankAddressRankingError {
  ANOTHER_STORE_IN_BRAND = "ANOTHER_STORE_IN_BRAND",
  OUT_OF_DELIVERY_AREA = "OUT_OF_DELIVERY_AREA",
}

/**
 * Sources from where the driver initiated the self assign
 */
export enum SelfAssignSource {
  alert = "alert",
  caterer_accept = "caterer_accept",
  food_prep = "food_prep",
  qrcode = "qrcode",
  sms = "sms",
}

/**
 * The current status of whether the owner of a phone number has consented to receive certain SMS messages at that number.
 */
export enum SmsConsentStatusEnum {
  opted_out = "opted_out",
  pending = "pending",
  terms_accepted = "terms_accepted",
  terms_rejected = "terms_rejected",
}

/**
 * Allowed values for query sorting
 */
export enum SortDirection {
  ASC = "ASC",
  DESC = "DESC",
}

export enum SourceNameEnum {
  direct_entry = "direct_entry",
  ezo = "ezo",
  marketplace = "marketplace",
  relish = "relish",
}

/**
 * Allowed values for the review stars field
 */
export enum StarRating {
  FIVE = "FIVE",
  FOUR = "FOUR",
  ONE = "ONE",
  THREE = "THREE",
  TWO = "TWO",
  ZERO = "ZERO",
}

/**
 * Allowed values for individual store performance sorting
 */
export enum StorePerformanceStoresSortField {
  AVERAGE_ORDER_VALUE = "AVERAGE_ORDER_VALUE",
  NICKNAME = "NICKNAME",
  TOTAL_FOOD = "TOTAL_FOOD",
  TOTAL_ORDER_COUNT = "TOTAL_ORDER_COUNT",
  TOTAL_SALES = "TOTAL_SALES",
}

/**
 * Allowed values for the order event time window used to roll up performance data.
 */
export enum StorePerformanceTimespan {
  CUSTOM = "CUSTOM",
  MONTH = "MONTH",
  WEEK = "WEEK",
  YEAR = "YEAR",
}

/**
 * Allowed values for the marketing activities sort field
 */
export enum SupplierMarketingActivitySortField {
  CAMPAIGN_NAME = "CAMPAIGN_NAME",
  DATE = "DATE",
  DESCRIPTION = "DESCRIPTION",
  TOTAL = "TOTAL",
  TRANSACTION_TYPE = "TRANSACTION_TYPE",
}

export enum TaxFormStatus {
  approved = "approved",
  expired = "expired",
  not_started = "not_started",
  pending = "pending",
  submitted = "submitted",
  submitted_for_review = "submitted_for_review",
  unregistered = "unregistered",
}

/**
 * Values for the reasons a vendor payment is being held
 */
export enum VendorPaymentHoldReasonEnum {
  MINIMUM_PAYMENT_AMOUNT = "MINIMUM_PAYMENT_AMOUNT",
}

/**
 * Allowed values for the vendor payment item sort field
 */
export enum VendorPaymentItemSortFieldEnum {
  ADDRESS_NAME = "ADDRESS_NAME",
  ADDRESS_STREET = "ADDRESS_STREET",
  AMOUNT_PAID = "AMOUNT_PAID",
  EVENT_AT = "EVENT_AT",
  ORDER_NUMBER = "ORDER_NUMBER",
  ORDER_SOURCE = "ORDER_SOURCE",
}

/**
 * Allowed values for vendor payment sort field
 */
export enum VendorPaymentSortField {
  AMOUNT = "AMOUNT",
  METHOD = "METHOD",
  SENT_ON = "SENT_ON",
}

/**
 * Required and optional fields used to build an address
 */
export interface AddressFields {
  city: string;
  deliveryInstructions?: string | null;
  driverAskFor?: string | null;
  name?: string | null;
  phone?: string | null;
  state: string;
  street1: string;
  street2?: string | null;
  zip: string;
}

/**
 * Autogenerated input type of AssignDriver
 */
export interface AssignDriverInput {
  clientMutationId?: string | null;
  deliveryId: string;
  driverId: string;
  source?: SelfAssignSource | null;
}

/**
 * Specifies the input fields to the rule for auto-requesting ezDispatch on an order.
 */
export interface AutoEzDispatchRuleInput {
  comparator?: AutoEzDispatchRuleComparator | null;
  enabled?: boolean | null;
  id?: string | null;
  key?: AutoEzDispatchRuleKey | null;
  schedule?: AutoEzDispatchRuleScheduleInput | null;
  value?: string | null;
}

/**
 * Specifies the input fields for the rule schedule. The schedule controls which
 * datetime the rule can be applied on. It's checked against the current datetime
 * when the rule engine is evaluated. If the schedule time is outside the current
 * datetime then the rule will be skipped during evaluation.
 */
export interface AutoEzDispatchRuleScheduleInput {
  dayOfWeek?: DaysOfWeek | null;
  endTime: GraphqlCustomScalar_LocalTime;
  startTime: GraphqlCustomScalar_LocalTime;
}

/**
 * Specifies the input fields to the rule set for auto-requesting ezDispatch on an order.
 */
export interface AutoEzDispatchRuleSetInput {
  disjunctiveRules?: boolean | null;
  id?: string | null;
  rules?: AutoEzDispatchRuleInput[] | null;
}

/**
 * Input type for creating a Branded Marketplace promo item
 */
export interface BrandedMarketplacePromoInput {
  catererUuids: string[];
  discountAmount?: number | null;
  discountType: DiscountTypeEnum;
  expiresOn: string;
  name: string;
  orderMinimum?: number | null;
  utmCampaign?: string | null;
  utmMedium?: string | null;
  utmSource?: string | null;
  weekdayOnly?: boolean | null;
}

/**
 * Autogenerated input type of CancelAllRequests
 */
export interface CancelAllRequestsInput {
  cancelledById?: string | null;
  cancelledByType?: ActorTypes | null;
  clientMutationId?: string | null;
  message?: string | null;
  orderId: string;
  requesterId?: string | null;
  requesterType?: ActorTypes | null;
}

/**
 * Additional context associated with CatererOrderActions
 */
export interface CatererOrderActionsAdditionalContextInput {
  fromSms?: boolean | null;
}

/**
 * Arguments for sorting catering partner accounts.
 */
export interface CateringPartnerAccountSort {
  direction: SortDirection;
  field: CateringPartnerAccountSortField;
}

/**
 * Assignable attributes for a store group associated with a catering partner account.
 */
export interface CateringPartnerStoreGroupInput {
  name: string;
}

/**
 * Autogenerated input type of ChangeDriver
 */
export interface ChangeDriverInput {
  assignDriverId: string;
  clientMutationId?: string | null;
  deliveryId: string;
  unassignDriverId: string;
}

/**
 * Autogenerated input type of CompleteMessageThread
 */
export interface CompleteMessageThreadInput {
  clientMutationId?: string | null;
  completedById: string;
  completedByType: ActorTypes;
  orderInfo: OrderInfoInput;
}

/**
 * Input used to update a contact's preferences for a particular notification
 */
export interface ContactNotificationPreferenceInput {
  type: ContactNotificationTypes;
  value: boolean;
}

/**
 * Input used to represent the number and label for a contact's phone number
 */
export interface ContactPhoneNumberInput {
  label: ContactPhoneNumberTypesEnum;
  number: string;
}

/**
 * Inputs for creating a contact promo
 */
export interface ContactPromoInput {
  catererUuids: string[];
  code: string;
  discountAmount: number;
  discountType: DiscountTypeEnum;
  expiresOn: string;
  name: string;
  orderMinimum: number;
  singleUsePerUser: boolean;
  weekdayOnly: boolean;
}

/**
 * Input type for creating an order item
 */
export interface CreateOrderItemInputType {
  labelFor?: string | null;
  menuItemId: string;
  optionInputs?: OrderItemOptionInputType[] | null;
  orderId: string;
  quantity: number;
  size?: string | null;
  specialInstructions?: string | null;
  totalPrice?: MoneyInput | null;
  vegetarianQuantity?: number | null;
}

/**
 * Fields to update the daily order capacity for a store
 */
export interface DailyOrderCapacity {
  breakfastCount?: GraphqlCustomScalar_PositiveInt | null;
  dayOfWeek: DaysOfWeek;
  dinnerCount?: GraphqlCustomScalar_PositiveInt | null;
  lunchCount?: GraphqlCustomScalar_PositiveInt | null;
  orderCount?: GraphqlCustomScalar_PositiveInt | null;
}

/**
 * Required fields used to create demographic profiles for caterers.
 */
export interface DemographicProfileUpsert {
  catererIds: string[];
  certification?: boolean | null;
  certificationDetails?: string | null;
  consentForDataUse: boolean;
  disability?: string | null;
  disabledVeteran?: string | null;
  gender?: GenderDemographic[] | null;
  lgbtqiaPlusCommunity?: string | null;
  ownershipCategory?: OwnershipCategoryDemographic | null;
  ownershipPercentage?: OwnershipPercentageDemographic | null;
  race?: RaceDemographic[] | null;
  smallBusiness?: string | null;
  veteran?: string | null;
}

/**
 * The input fields for creating or updating a caterer's delivery driver.
 */
export interface DmDriverInput {
  ezcaterStoreIds: string[];
  firstName: string;
  lastName: string;
  makeModel?: string | null;
  notes?: string | null;
  phone?: string | null;
}

/**
 * Autogenerated input type of DriverCreate
 */
export interface DriverCreateInput {
  clientMutationId?: string | null;
  driver: DmDriverInput;
}

/**
 * Autogenerated input type of DriverDelete
 */
export interface DriverDeleteInput {
  clientMutationId?: string | null;
  id: string;
}

/**
 * Autogenerated input type of DriverEdit
 */
export interface DriverEditInput {
  clientMutationId?: string | null;
  driver: DmDriverInput;
  id: string;
}

/**
 * Autogenerated input type of ExportDeliveryReportingData
 */
export interface ExportDeliveryReportingDataInput {
  clientMutationId?: string | null;
  eventAtRange: TimeRangeInput;
  ezcaterStoreIds: string[];
}

/**
 * Input used to update the value of an ezManage permission.
 */
export interface EzManagePermissionInput {
  type: EzManagePermissionTypes;
  value: boolean;
}

/**
 * Input type for specifying file upload details
 */
export interface FileUpload {
  contentType: string;
  filename: string;
}

export interface FilterInput {
  comparatorTarget: ComparatorTargetEnum;
  endDate: GraphqlCustomScalar_Date;
  entityIds: string[];
  entityType: EntityTypeEnum;
  ezcaterSourceName: SourceNameEnum[];
  granularity: GranularityEnum;
  startDate: GraphqlCustomScalar_Date;
}

/**
 * Represents open/close times for a given day of the week
 */
export interface HoursOfOperationType {
  closeTime: GraphqlCustomScalar_TimeWithoutZone;
  day: string;
  openTime: GraphqlCustomScalar_TimeWithoutZone;
}

/**
 * Attributes for each order item change
 */
export interface ItemChangeInput {
  changeType: OrderItemChangeTypes;
  originalItemJson: string;
  proposedItemJson: string;
  reason?: string | null;
}

/**
 * Arguments for sorting a list menu item sales analyses.
 */
export interface MenuItemSalesAnalysisSortInput {
  direction: SortDirection;
  field: MenuItemSalesAnalysisSort;
}

export interface MoneyInput {
  currency?: Currency | null;
  subunits: number;
}

/**
 * Allowed values for operating schedule object arguments.
 */
export interface OperatingScheduleInput {
  operatingHours: HoursOfOperationType[];
  scheduleType: string;
}

/**
 * Arguments for sorting a list of stores for a caterer account on the operational metrics page.
 */
export interface OperationalMetricsStoreSortInput {
  direction: SortDirection;
  field: OperationalMetricsStoreSortField;
}

/**
 * Attributes for order detail information
 */
export interface OrderInfoInput {
  brandName: string;
  eventAt: GraphqlCustomScalar_ISO8601DateTime;
  eventTimeZone?: string | null;
  id: string;
  isPickup?: boolean | null;
  orderNumber: string;
  userUuid: string;
}

/**
 * Input type for an order item choice
 */
export interface OrderItemChoiceInputType {
  menuChoiceId: string;
  quantity?: number | null;
}

/**
 * Input type for an order item option
 */
export interface OrderItemOptionInputType {
  choiceInputs?: (OrderItemChoiceInputType | null)[] | null;
  menuOptionId: string;
}

/**
 * Arguments for creating OrderReadyForPickupMetadatum
 */
export interface OrderReadyForPickupMetadatumInput {
  foodMarkedReadyForPickupAt: GraphqlCustomScalar_ISO8601DateTime;
  foodMarkedReadyForPickupByContactId?: string | null;
  numberOfPackages: number;
  orderId: string;
  pdfPrintedByContactId?: string | null;
  photoDeletedAt?: GraphqlCustomScalar_ISO8601DateTime | null;
  photoDeletedByContactId?: string | null;
  photoKey?: string | null;
}

/**
 * Arguments for sorting orders
 */
export interface OrderSortInputType {
  direction: SortDirection;
  field: CatererOrderSortField;
}

/**
 * Arguments for sorting orders for a promo
 */
export interface PromoOrderSortType {
  direction: SortDirection;
  field: PromoOrderSortField;
}

/**
 * Autogenerated input type of RecordDecision
 */
export interface RecordDecisionInput {
  adminUserUuid?: string | null;
  clientMutationId?: string | null;
  comment?: string | null;
  decisionUuid: string;
  responderComment?: string | null;
  response: boolean;
}

/**
 * Autogenerated input type of RecordMessage
 */
export interface RecordMessageInput {
  clientMutationId?: string | null;
  content: string;
  initiatorType?: ActorTypes | null;
  initiatorUuid?: string | null;
  orderInfo: OrderInfoInput;
  sentById?: string | null;
  sentByType?: ActorTypes | null;
}

/**
 * Input type for creating a new Registered Business
 */
export interface RegisteredBusinessCreateInput {
  address?: AddressFields | null;
  addressId?: string | null;
  federalTaxId: string;
  name: string;
  storeIds?: string[] | null;
}

/**
 * Input type for updating a Registered Business
 */
export interface RegisteredBusinessUpdateInput {
  address?: AddressFields | null;
  addressId?: string | null;
  federalTaxId?: string | null;
  id: string;
  name?: string | null;
  storeIds?: string[] | null;
}

/**
 * Autogenerated input type of RequestDeliveryTimeChangeCP
 */
export interface RequestDeliveryTimeChangeCPInput {
  clientMutationId?: string | null;
  contactUuid?: string | null;
  content?: string | null;
  orderInfo: OrderInfoInput;
  originalEventAt: GraphqlCustomScalar_ISO8601DateTime;
  proposedEventAt: GraphqlCustomScalar_ISO8601DateTime;
  reason: string;
  requestedById?: string | null;
}

/**
 * Autogenerated input type of RequestOrderItemChangeCP
 */
export interface RequestOrderItemChangeCPInput {
  clientMutationId?: string | null;
  contactUuid?: string | null;
  content?: string | null;
  itemChanges: ItemChangeInput[];
  orderInfo: OrderInfoInput;
  reason?: string | null;
  requestedById?: string | null;
}

/**
 * Autogenerated input type of SetMessageStatus
 */
export interface SetMessageStatusInput {
  clientMutationId?: string | null;
  messageId: string;
  reviewedById: string;
  reviewedByType: ActorTypes;
  status: MessageStatus;
}

/**
 * Attributes for editing a topsort sponsored listing campaign group
 */
export interface SponsoredListingCampaignGroupInput {
  autoBidGoal?: AutoBidGoalEnum | null;
  bidAmountCents?: number | null;
  budgetAmountCents?: number | null;
  catererIdsToAdd?: string[] | null;
  endDate?: GraphqlCustomScalar_DateTime | null;
  name?: string | null;
  startDate?: GraphqlCustomScalar_DateTime | null;
}

/**
 * Attributes for creating a topsort sponsored listing campaign
 */
export interface SponsoredListingCampaignInput {
  autoBidGoal?: AutoBidGoalEnum | null;
  bidAmountCents?: number | null;
  budgetAmountCents: number;
  catererIdsToAdd: string[];
  endDate?: GraphqlCustomScalar_DateTime | null;
  groupType?: GroupTypeEnum | null;
  marketingPartnerId?: number | null;
  name: string;
  startDate?: GraphqlCustomScalar_DateTime | null;
}

/**
 * Arguments for filtering store performance data
 */
export interface StorePerformanceStoresFilterInput {
  endDate?: GraphqlCustomScalar_Date | null;
  orderSources?: (OrderSource | null)[] | null;
  startDate?: GraphqlCustomScalar_Date | null;
  timespan?: StorePerformanceTimespan | null;
}

/**
 * Allowed values for temporary closure object arguments.
 */
export interface TemporaryClosureInput {
  endOn: GraphqlCustomScalar_Date;
  endTime?: GraphqlCustomScalar_TimeWithoutZone | null;
  ids?: string[] | null;
  markedForDestruction?: boolean | null;
  marketplace?: boolean | null;
  relish?: boolean | null;
  startOn: GraphqlCustomScalar_Date;
  startTime?: GraphqlCustomScalar_TimeWithoutZone | null;
}

/**
 * Range of timestamps
 */
export interface TimeRangeInput {
  ending: GraphqlCustomScalar_ISO8601DateTime;
  starting: GraphqlCustomScalar_ISO8601DateTime;
}

/**
 * Autogenerated input type of UnassignDriver
 */
export interface UnassignDriverInput {
  clientMutationId?: string | null;
  deliveryId: string;
  driverId: string;
}

/**
 * Required fields used to update stores daily capacities
 */
export interface UpdateDailyOrderCapacities {
  automaticTempClosure?: boolean | null;
  capacityLimitType?: CapacityLimit | null;
  catererIds: string[];
  dailyOrderCapacities: DailyOrderCapacity[];
}

/**
 * Input type for updating a menu
 */
export interface UpdateMenuInputType {
  contactName: string;
  email: string;
  hasMultipleLocations: boolean;
  isIndividuallyPackaged?: boolean | null;
  locations?: string[] | null;
  menuFiles?: GraphqlCustomScalar_File[] | null;
  menuUpdateDestination?: MenuUpdateDestination | null;
  menuUrl?: string | null;
  phone: string;
  specificInstructions: string;
  storeId: string;
  updateNotes?: string | null;
  updates: string[];
}

/**
 * Input type for updating an order item
 */
export interface UpdateOrderItemInputType {
  id: string;
  optionInputs?: OrderItemOptionInputType[] | null;
  orderId: string;
  quantity: number;
  size?: string | null;
  specialInstructions?: string | null;
  vegetarianQuantity?: number | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
